module.exports = __webpack_public_path__ + "static/media/logo-dp-on-tp.52e425de.svg";